module.exports = __webpack_public_path__ + "static/media/SearchIcon.d3031458.svg";